import(/* webpackMode: "eager" */ "/vercel/path0/ui/src/app/swap/[[...swapPair]]/page.tsx");
